<template>
    <div class="message button-message">
        <div class="bot-response button">
            <div class="button-content">
                <div class="button-description" v-html="data.message"></div>
            </div>
            <div class="buttons">
                <div
                    class="single-button"
                    v-for="(button, i) in data.buttons"
                    :class="{ selected: $_.get(lastClickedButton, 'buttonId') === button.id }"
                    :key="button.id"
                    @click="
                        sendButtonMessage('BUTTON', {
                            buttonId: button.id,
                            blockId: data.blockId,
                            payloadId: data.id,
                            buttonPayload: button.payload,
                        })
                    "
                >
                    <div class="single-button-text" v-html="button.title" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import { sendSocketMessage } from "../../../../utils/socketStream";
import { mapState } from "vuex";

export default {
    name: "BotButtonMessage",
    props: {
        data: {
            type: Object,
            required: true,
            default: () => ({
                buttons: [],
                message: "",
                id: "",
                blockId: "",
            }),
        },
        conversationId: {
            type: String,
            required: true,
        },
        lastClickedButton: {
            type: Object,
            required: null,
        },
    },
    computed: {
        ...mapState({
            siteId: (state) => _.get(state.site.site, "_id"),
        }),
        isReadOnly() {
            return !this.conversationId.startsWith("test-");
        },
    },
    data() {
        return {
            clickedButton: null,
        };
    },
    methods: {
        sendButtonMessage(type, payload) {
            if (this.isReadOnly) return;
            this.clickedButton = payload.buttonId;
            const command = this.conversationId.startsWith("test-")
                ? "chatbot/v2 test-user-button-select"
                : "chatbot/v2 user-button-select";
            sendSocketMessage(command, {
                siteId: this.siteId,
                conversationId: this.conversationId,
                type,
                payload,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.message.button-message {
    border: 1px solid;
    border-radius: 10px;
    overflow: hidden;
    width: 240px;
    border-color: rgb(219, 225, 232);
    background: rgb(255, 255, 255);
    margin-bottom: 35px;

    .button-content {
        display: flex;
        flex-direction: column;
        padding: 0 20px 30px;

        .button-description {
            word-wrap: break-word;
            font-size: 16px;
            line-height: 20px;
            margin-top: 12px;
            white-space: pre-wrap;
            color: rgb(0, 0, 0);
        }
    }

    .buttons {
        display: flex;
        flex-direction: column;
        width: 100%;

        .single-button {
            align-items: center;
            border-top: 1px solid;
            cursor: pointer;
            display: flex;
            font-weight: 600;
            min-height: 45px;
            padding: 0 10px;
            transition: all 0.3s;
            background: rgb(255, 255, 255);
            border-top-color: rgb(219, 225, 232);

            &.selected {
                background: rgb(0, 108, 255);

                .single-button-text {
                    color: white;
                }
            }

            &:hover {
                opacity: 0.8 !important;
            }

            .single-button-text {
                overflow: hidden !important;
                text-align: center;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
                color: rgb(0, 108, 255);
            }
        }
    }
}
</style>
